/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".abcRioButton{border-radius:30px!important}  span[id^=not_signed_]:before{content:'Ingresar con Google';padding-right:20px}  span[id^=connected]:before{content:'Ingres\u00F3 con Google ';padding-right:20px}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
